jQuery(document).ready(function () {
    $('.dnTextPreview').each(function () {
        var object = $(this);
        var textContainer = object.find('.dnTextPreview-text');

        var textContainerHeight = textContainer[0].scrollHeight;
        var thresholdHeight = 200;

        if(textContainerHeight < thresholdHeight) {
            object.addClass('dnTextPreview-shortText')
        }
    });
});
